import { simpleMp3 } from 'simple-mp3'

export const encodeMP3 = samples => {
  const data = simpleMp3({
    channelData: samples,
    sampleRate: 16000
  })
  return new Blob(data, { type: "audio/mp3" })
}
